module.exports = __webpack_public_path__ + "img/profile.3773b777.svg";